<script lang="ts" setup>
import {viewportSize} from '@teemill/common/helpers';
import {faArrowRight} from '@fortawesome/pro-light-svg-icons';
import ExchangeItemCard from './ExchangeItemCard.vue';
import {ExchangeItem} from './types/exchangeItem';

defineProps<{
  exchangeItem: ExchangeItem;
}>();

const mobileView = viewportSize.isSmaller('md');
</script>

<template>
  <div>
    <component
      :is="mobileView ? 'h5' : 'h4'"
      class="font-bold text-nowrap mb-0"
    >
      {{ exchangeItem.product.name }}
    </component>
    <div
      class="flex flex-wrap"
      :class="mobileView ? 'justify-between' : 'gap-3'"
    >
      <div class="w-1/3 md:w-1/6 mt-4">
        <exchange-item-card
          :item="exchangeItem"
          label="Original item"
          :mobile-view="mobileView"
        />
      </div>
      <div class="self-center w-1/4 md:w-1/5 self-center flex justify-center">
        <font-awesome-icon
          :icon="faArrowRight"
          :class="mobileView ? 'mb-12' : 'mb-6'"
          :style="{fontSize: mobileView ? '2.5em' : '3em', opacity: 0.15}"
        />
      </div>
      <div class="w-1/3 md:w-1/6 mt-4">
        <exchange-item-card
          :item="exchangeItem.exchangeFor"
          label="Exchange item"
          :mobile-view="mobileView"
        />
      </div>
    </div>
  </div>
</template>
